import { AnimatedSection } from "../shared";
import { IconPerson, IconProcessor, IconGlobe } from "../shared/icons";

const STEPS = [
  { num: "01", title: "Sign Up", desc: "Create an account. Your personal hub server is provisioned automatically. No setup, no waiting, no devops.", icon: <IconPerson /> },
  { num: "02", title: "Pick Your Agents", desc: "Browse the Agent Library. Activate the blocks you need by choosing from yield optimizer, arb bot, reply guy, portfolio tracker, and more. Each agent runs independently.", icon: <IconProcessor /> },
  { num: "03", title: "Run From Anywhere", desc: "Manage your hub from the browser extension, desktop app (Win/Mac), or mobile. Your agents work 24/7, even when you don't.", icon: <IconGlobe /> },
] as const;

export function HowItWorks() {
  return (
    <section className="py-12 md:py-16 px-6 relative overflow-hidden bg-[#f5f5f5]">
      <div className="max-w-7xl mx-auto w-full relative z-10">
        <AnimatedSection>
          <div className="mb-12 text-center flex flex-col items-center">
            <span className="inline-flex items-center gap-2.5 text-[11px] font-semibold tracking-[0.2em] uppercase text-black/40 mb-5 before:content-[''] before:w-5 before:h-px before:bg-gradient-to-r before:from-black/30 before:to-transparent">
              Process
            </span>
            <h2 className="font-space-grotesk text-4xl md:text-6xl font-bold tracking-[-0.03em] text-black">How It Works</h2>
            <p className="text-lg text-black/50 mt-5 max-w-2xl">
              From zero to running agents in under 2 minutes.
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {STEPS.map((step, i) => (
            <AnimatedSection key={step.num} delay={i * 0.15}>
              <div className="h-full bg-white border border-black/[0.08] p-10 rounded-2xl group hover:border-black/[0.15] transition-all duration-500 hover:shadow-lg">
                <div className="flex flex-col h-full">
                  <div className="flex items-center justify-between mb-10">
                    <span className="font-space-grotesk text-5xl font-bold text-black/[0.08]">{step.num}</span>
                    <div className="text-black/25 group-hover:text-black/40 transition-colors">
                      {step.icon}
                    </div>
                  </div>
                  <h3 className="font-space-grotesk text-xl font-bold mb-3 text-black">{step.title}</h3>
                  <p className="text-black/50 text-base leading-relaxed">{step.desc}</p>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
